import { PluginKey } from '@atlaskit/editor-prosemirror/state';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';
import type { ReferentialityPluginState } from '../types';

export const pluginKey: PluginKey<ReferentialityPluginState> =
	new PluginKey<ReferentialityPluginState>('referentialityPlugin');
export const getPluginState = (state: EditorState): ReferentialityPluginState | undefined | null =>
	state && pluginKey.getState(state);
